import { UserType } from "@/common/types";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Minimize2 } from "lucide-react";
import Details from "./details";
import { useEffect, useState } from "react";
import { capitalize } from "@/utils/common.util";
import { useDispatch } from "react-redux";
import { getMedicalHistory } from "@/redux/actions/usersActions";

interface DetailedViewProps {
  onClose: () => void;
  users: UserType[];
  selectedUser: UserType;
}

const DetailedView = ({ onClose, users, selectedUser }: DetailedViewProps) => {
  const [user, setUser] = useState<UserType>(selectedUser);

  const dispatch: any = useDispatch();

  const handleSelectUser = (user: UserType) => {
    setUser(user);
  };

  useEffect(() => {
    if (user.role === "patient") {
      dispatch(getMedicalHistory(user.id as number));
    }
  }, [user]);

  return (
    <div className="md:p-8">
      <div className="grid grid-cols-6 sm:grid-cols-6 md:grid-cols-3 lg:grid-cols-4">
        <div className="hidden md:block md:col-span-1 lg:col-span-1">
          <ScrollArea className="h-[calc(100vh-150px)] overflow-auto scrollbar-hide border-l border-r border-solid border-gray-200">
            {users.map((user, idx) => (
              <Card
                key={idx}
                className="cursor-pointer m-2"
                onClick={() => handleSelectUser(user)}
              >
                <CardHeader>
                  <CardTitle>{user.name}</CardTitle>
                  <CardDescription>{user.email}</CardDescription>
                  <CardDescription>{capitalize(user.role)}</CardDescription>
                </CardHeader>
              </Card>
            ))}
          </ScrollArea>
        </div>
        <div className="col-span-6 sm:col-span-6 md:col-span-2 lg:col-span-3">
          <div className="cursor-pointer flex items-center justify-end">
            <Minimize2 onClick={onClose} />
          </div>
          <Details selectedUser={user} />
        </div>
      </div>
    </div>
  );
};

export default DetailedView;
